import { Compass, BarChart3, ClipboardCheck } from "lucide-react";
import Reveal from "./Reveal";

const STEPS = [
  {
    icon: Compass,
    title: "Definisci ciò che vuoi ottenere",
    body:
      "OrizzontiPro parte dal progetto, dai tempi, dai vincoli e dal risultato desiderato.",
  },
  {
    icon: BarChart3,
    title: "Comprendi il potenziale dell'immobile",
    body:
      "ValutaPro esamina caratteristiche, zona e fattori che incidono sulla stima indicativa e sulla vendibilità.",
  },
  {
    icon: ClipboardCheck,
    title: "Scopri cosa affrontare prima",
    body:
      "PartenzaPro individua documenti, criticità, tempi e priorità.",
  },
];

export default function ThreeSteps() {
  return (
    <section
      data-testid="three-steps-section"
      className="bg-[#404040] py-20 md:py-28 relative overflow-hidden"
    >
      {/* Subtle vignette */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/20 pointer-events-none" />

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <h2 className="font-display font-bold text-white text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight">
            Tre analisi. <span className="text-white/80">Una decisione vista da tre angolazioni.</span>
          </h2>
        </Reveal>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-0 relative">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <Reveal
                key={step.title}
                delay={i * 120}
                className={`px-2 md:px-8 text-center md:text-left relative ${
                  i < STEPS.length - 1 ? "md:border-r md:border-white/10" : ""
                }`}
              >
                <div className="mx-auto md:mx-0 w-14 h-14 rounded-xl border border-white/15 bg-white/5 flex items-center justify-center mb-6">
                  <Icon className="w-6 h-6 text-white" strokeWidth={2} />
                </div>
                <div className="text-white/40 font-mono text-xs tracking-widest mb-2">
                  0{i + 1}
                </div>
                <h3 className="font-display font-bold text-white text-2xl md:text-3xl tracking-tight mb-3 leading-snug">
                  {step.title}
                </h3>
                <p className="text-white/75 text-[16px] md:text-[17px] leading-relaxed">
                  {step.body}
                </p>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={360} className="mt-16 md:mt-20 flex justify-center">
          <div
            data-testid="three-steps-closing"
            className="max-w-[720px] mx-auto bg-black/20 border border-white/10 rounded-xl px-6 md:px-10 py-7 md:py-9 text-center backdrop-blur-sm"
          >
            <p className="text-white/85 text-[15px] md:text-[17px] leading-relaxed">
              Puoi fermarti dopo qualsiasi analisi. Completando il percorso costruisci un quadro più utile per te e per l&apos;eventuale confronto con il Property Advisor.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
